// src/actions/certificadoActions.js
import { getCertificadoByCodigo } from '../services/certificadoService';

export const CERT_FETCH_REQ = 'CERT_FETCH_REQ';
export const CERT_FETCH_OK  = 'CERT_FETCH_OK';
export const CERT_FETCH_ERR = 'CERT_FETCH_ERR';

export function fetchCertificadoByCodigo(codigo) {
  return async (dispatch) => {
    try {
      dispatch({ type: CERT_FETCH_REQ, payload: { codigo } });
      const data = await getCertificadoByCodigo(codigo);
      dispatch({ type: CERT_FETCH_OK, payload: data });
      return data;
    } catch (err) {
      dispatch({
        type: CERT_FETCH_ERR,
        error: err?.response?.data?.message || err.message || 'Error al verificar certificado'
      });
      throw err;
    }
  };
}